import {MANIFEST_POST_SEND_TO_SIGN_CAP} from "../axios";

export const axiosPostSendToSignCaptainMan = async (axiosPrivate, manId, getRequestDataToggle, cargoCaseDocId, getIdCreateDoc, getIdUpdateMan, setActiveModal) => {
    try {
        const response = await axiosPrivate.post(MANIFEST_POST_SEND_TO_SIGN_CAP + manId)
        let promise = new Promise((resolve, reject) => {
            resolve(response)
        })
        promise.then(
            function (response) {
                getRequestDataToggle()
                return new Promise((resolve, reject) => {
                    resolve(response)
                })
            }).then(
            function (response) {
                if (cargoCaseDocId !== undefined) {
                    getIdCreateDoc(cargoCaseDocId)
                    getIdUpdateMan(manId)
                } else {
                    getIdUpdateMan(manId)
                }
            }).catch(
            function (error) {
                console.log(error)
            })
        setActiveModal(false);
    } catch (err) {
        setActiveModal(false);
        console.error(err);
    }
}
